import { render, staticRenderFns } from "./EthiopianCalendar.vue?vue&type=template&id=b75e1bd2&scoped=true"
import script from "./EthiopianCalendar.vue?vue&type=script&lang=js"
export * from "./EthiopianCalendar.vue?vue&type=script&lang=js"
import style0 from "./EthiopianCalendar.vue?vue&type=style&index=0&id=b75e1bd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75e1bd2",
  null
  
)

export default component.exports